import { render, staticRenderFns } from "./PlayGuide.vue?vue&type=template&id=3f5db401&scoped=true"
import script from "./PlayGuide.vue?vue&type=script&lang=js"
export * from "./PlayGuide.vue?vue&type=script&lang=js"
import style0 from "./PlayGuide.vue?vue&type=style&index=0&id=3f5db401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5db401",
  null
  
)

export default component.exports